<template>
  <div class="menu-management">
    <!-- 搜索栏 -->
    <el-card class="search-card">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="菜单名称">
          <el-input v-model="searchForm.name" placeholder="请输入菜单名称" clearable style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="searchForm.type" placeholder="请选择" clearable style="width: 140px;">
            <el-option label="菜单" :value="1"></el-option>
            <el-option label="按钮/操作" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" icon="el-icon-search">查询</el-button>
          <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 表格区域 -->
    <el-card class="table-card">
      <div slot="header" class="clearfix">
        <span>菜单列表</span>
        <el-button style="float: right;" type="primary" size="small" icon="el-icon-plus" @click="handleAdd(null)">新增菜单</el-button>
      </div>

      <el-table
        :data="filteredTableData"
        border
        stripe
        row-key="id"
        v-loading="tableLoading"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        default-expand-all
      >
        <el-table-column prop="name" label="菜单名称" min-width="160">
          <template slot-scope="scope">
            <span>
              <i :class="scope.row.icon || 'el-icon-menu'" style="margin-right: 6px; color: #FF8C00;"></i>
              {{ scope.row.name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="path" label="路由路径" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="component" label="组件路径" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="permission" label="权限标识" width="160">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.permission" type="info" size="small">{{ scope.row.permission }}</el-tag>
            <span v-else style="color: #C0C4CC;">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="类型" width="110">
          <template slot-scope="scope">
            <el-tag :type="scope.row.type === 1 ? 'warning' : 'info'" size="small">
              {{ scope.row.type === 1 ? '菜单' : '按钮/操作' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="80" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small">
              {{ scope.row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="220">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleAdd(scope.row)">新增子级</el-button>
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button
              type="text"
              size="small"
              @click="handleDelete(scope.row)"
              style="color: #F56C6C;"
              :disabled="scope.row.id === 1"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      @close="handleDialogClose"
    >
      <el-form :model="dialogForm" :rules="dialogRules" ref="dialogForm" label-width="100px">
        <el-form-item label="菜单类型" prop="type">
          <el-radio-group v-model="dialogForm.type">
            <el-radio :label="1">菜单</el-radio>
            <el-radio :label="2">按钮/操作</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="上级菜单" prop="parentId">
          <el-cascader
            v-model="dialogForm.parentId"
            :options="menuCascaderOptions"
            :props="{ checkStrictly: true, label: 'name', value: 'id', emitPath: false }"
            placeholder="请选择上级菜单（选一级菜单留空）"
            clearable
            style="width: 100%;"
          ></el-cascader>
        </el-form-item>

        <el-form-item label="菜单名称" prop="name">
          <el-input v-model="dialogForm.name" placeholder="请输入菜单名称" maxlength="50"></el-input>
        </el-form-item>

        <template v-if="dialogForm.type === 1">
          <el-form-item label="路由路径" prop="path">
            <el-input v-model="dialogForm.path" placeholder="请输入路由路径，如 /user" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item label="组件路径" prop="component">
            <el-input v-model="dialogForm.component" placeholder="请输入组件路径，如 views/user/UserManagement" maxlength="200"></el-input>
          </el-form-item>
          <el-form-item label="菜单图标" prop="icon">
            <el-input v-model="dialogForm.icon" placeholder="请输入图标类名，如 el-icon-user" maxlength="50">
              <template slot="prepend">
                <i :class="dialogForm.icon || 'el-icon-picture-outline'"></i>
              </template>
            </el-input>
          </el-form-item>
        </template>

        <template v-else>
          <el-form-item label="权限标识" prop="permission">
            <el-input v-model="dialogForm.permission" placeholder="请输入权限标识，如 user:add" maxlength="100"></el-input>
          </el-form-item>
        </template>

        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="dialogForm.sort" :min="0" :max="9999" controls-position="right" style="width: 100%;"></el-input-number>
        </el-form-item>

        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="dialogForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleDialogSubmit" :loading="dialogSubmitLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getMenuTree,
  getMenuTreeAll,
  getMenu,
  addMenu,
  updateMenu,
  deleteMenu
} from '@/api'

export default {
  name: 'MenuManagement',
  data() {
    return {
      searchForm: {
        name: '',
        type: null
      },
      tableData: [],
      tableLoading: false,

      // 对话框
      dialogVisible: false,
      dialogTitle: '新增菜单',
      dialogSubmitLoading: false,
      dialogForm: {
        id: null,
        type: 1,
        parentId: null,
        name: '',
        path: '',
        component: '',
        icon: '',
        permission: '',
        sort: 0,
        status: 1
      },
      dialogRules: {
        type: [{ required: true, message: '请选择菜单类型', trigger: 'change' }],
        name: [{ required: true, message: '请输入菜单名称', trigger: 'blur' }],
        path: [{ required: true, message: '请输入路由路径', trigger: 'blur' }],
        permission: [{ required: true, message: '请输入权限标识', trigger: 'blur' }]
      },

      // 级联选择器数据（只显示菜单类型，不显示按钮）
      menuCascaderOptions: []
    }
  },
  computed: {
    filteredTableData() {
      let data = JSON.parse(JSON.stringify(this.tableData))
      if (this.searchForm.name) {
        data = this.filterByName(data, this.searchForm.name.toLowerCase())
      }
      if (this.searchForm.type !== null && this.searchForm.type !== '') {
        data = this.filterByType(data, this.searchForm.type)
      }
      return data
    }
  },
  created() {
    this.loadData()
    this.loadMenuOptions()
  },
  methods: {
    async loadData() {
      this.tableLoading = true
      try {
        const res = await getMenuTreeAll()
        this.tableData = res.data || []
      } catch (e) {
        console.error(e)
      } finally {
        this.tableLoading = false
      }
    },

    async loadMenuOptions() {
      try {
        const res = await getMenuTree()
        this.menuCascaderOptions = res.data || []
      } catch (e) {
        console.error(e)
      }
    },

    handleSearch() {
      // computed 处理过滤，无需额外操作
    },

    handleReset() {
      this.searchForm = { name: '', type: null }
    },

    handleAdd(parent) {
      this.dialogTitle = parent ? `新增子级菜单「${parent.name}」` : '新增菜单'
      this.dialogForm = {
        id: null,
        type: 1,
        parentId: parent ? parent.id : null,
        name: '',
        path: '',
        component: '',
        icon: '',
        permission: '',
        sort: 0,
        status: 1
      }
      this.dialogVisible = true
    },

    async handleEdit(row) {
      try {
        const res = await getMenu(row.id)
        const menu = res.data
        this.dialogForm = {
          id: menu.id,
          type: menu.type,
          parentId: menu.parentId === 0 ? null : menu.parentId,
          name: menu.name,
          path: menu.path || '',
          component: menu.component || '',
          icon: menu.icon || '',
          permission: menu.permission || '',
          sort: menu.sort || 0,
          status: menu.status
        }
        this.dialogTitle = `编辑菜单「${menu.name}」`
        this.dialogVisible = true
      } catch (e) {
        console.error(e)
      }
    },

    handleDialogClose() {
      this.$refs.dialogForm.resetFields()
    },

    handleDialogSubmit() {
      this.$refs.dialogForm.validate(async (valid) => {
        if (!valid) return
        this.dialogSubmitLoading = true
        try {
          const { id, type, parentId, name, path, component, icon, permission, sort, status } = this.dialogForm
          const payload = { type, name, sort, status }
          // parentId 为 null 表示顶级
          payload.parentId = parentId || 0
          if (type === 1) {
            payload.path = path
            payload.component = component
            payload.icon = icon
          } else {
            payload.permission = permission
          }

          if (id) {
            await updateMenu(id, payload)
            this.$message.success('更新成功')
          } else {
            await addMenu(payload)
            this.$message.success('新增成功')
          }
          this.dialogVisible = false
          this.loadData()
          this.loadMenuOptions()
        } catch (e) {
          console.error(e)
        } finally {
          this.dialogSubmitLoading = false
        }
      })
    },

    async handleDelete(row) {
      const childCount = row.children ? row.children.length : 0
      const msg = childCount > 0
        ? `确定要删除菜单「${row.name}」及其 ${childCount} 个子菜单吗？`
        : `确定要删除菜单「${row.name}」吗？`

      try {
        await this.$confirm(msg, '提示', { type: 'warning' })
        await deleteMenu(row.id)
        this.$message.success('删除成功')
        this.loadData()
        this.loadMenuOptions()
      } catch (e) {
        if (e !== 'cancel') console.error(e)
      }
    },

    filterByName(data, keyword) {
      const result = []
      for (const item of data) {
        const match = item.name.toLowerCase().includes(keyword)
        const filteredChildren = this.filterByName(item.children || [], keyword)
        if (match || filteredChildren.length > 0) {
          result.push({
            ...item,
            children: filteredChildren.length > 0 ? filteredChildren : item.children
          })
        }
      }
      return result
    },

    filterByType(data, type) {
      const result = []
      for (const item of data) {
        const filteredChildren = this.filterByType(item.children || [], type)
        if (item.type === type || filteredChildren.length > 0) {
          result.push({
            ...item,
            children: filteredChildren.length > 0 ? filteredChildren : item.children
          })
        }
      }
      return result
    }
  }
}
</script>

<style scoped lang="scss">
.menu-management {
  padding: 20px;
}

.search-card {
  margin-bottom: 20px;
}

.table-card {
  min-height: 500px;
}
</style>
